module.exports = __webpack_public_path__ + "assets/img/00025.d263ac51.png";